import React from 'react';
import '../../assets/scss/dataTableCompact.scss';
import { ReactComponent as Down } from '../../assets/svg/down-arrow-search.svg';
import { ReactComponent as ChevronLeftIcon } from '../../assets/svg/chevron-left.svg';

import LoadingBar from '../components/global/loadingBar';

import jwt_decode from 'jwt-decode';
import { withRouter } from '../../services/withRoute';
import _ from 'lodash';
class DataTableCompact extends React.Component {
	constructor(props) {
		super();
		this.state = {
			search: false,
			activeSortBy: null,
			activeSortType: null,
		};
	}
	componentWillReceiveProps = (nextProps) => {
		if (nextProps.activeSortBy !== this.state.activeSortBy) {
			this.setState({
				activeSortBy: nextProps.activeSortBy,
			});
		}
		if (nextProps.activeSortType !== this.state.activeSortType) {
			this.setState({
				activeSortType: nextProps.activeSortType,
			});
		}
	};
	componentDidMount = () => {
		this.setState({
			activeSortBy: this.props.activeSortBy,
			activeSortType: this.props.activeSortType,
		});
		_.map(this.props.columns, (column, key) => {
			if (_.has(column, 'sortBy')) {
				if (column.sortBy !== this.state.activeSortBy) {
					this.setState({
						[`${column.sortBy}SortType`]: 0,
					});
				} else {
					this.setState({
						[`${column.sortBy}SortType`]: this.state.activeSortType,
					});
				}
			}
		});
	};
	componentDidUpdate = (prevProps, prevState) => {
		if (
			prevState.activeSortBy !== this.state.activeSortBy &&
			this.state.activeSortBy !== null
		) {
			_.map(this.props.columns, (column, key) => {
				if (_.has(column, 'sortBy')) {
					if (column.sortBy !== this.state.activeSortBy) {
						this.setState({
							[`${column.sortBy}SortType`]: 0,
						});
					} else {
						this.setState({
							[`${column.sortBy}SortType`]: this.state.activeSortType,
						});
					}
				}
			});
		}
	};

	fetchPageNumbers = () => {
		const totalPages = this.props.totalPages;
		const currentPage = this.props.currentViewPage;
		const pageNeighbours = 4;

		const LEFT_PAGE = 'Left';
		const RIGHT_PAGE = 'Right';
		const START_PAGE = 'Start';
		const LAST_PAGE = 'End';

		/**
		 * totalNumbers: the total page numbers to show on the control
		 * totalBlocks: totalNumbers + 2 to cover for the left(<) and right(>) controls
		 */
		const totalNumbers = pageNeighbours * 2 + 2;
		const totalBlocks = totalNumbers + 2;

		if (totalPages > totalBlocks) {
			const startPage = Math.max(2, currentPage - pageNeighbours);
			const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
			let pages = _.range(startPage, endPage + 1);

			/**
			 * hasLeftSpill: has hidden pages to the left
			 * hasRightSpill: has hidden pages to the right
			 * spillOffset: number of hidden pages either to the left or to the right
			 */
			const hasLeftSpill = startPage > 2;
			const hasRightSpill = totalPages - endPage > 1;
			const spillOffset = totalNumbers - (pages.length + 1);

			switch (true) {
				// handle: (1) < {5 6} [7] {8 9} (10)
				case hasLeftSpill && !hasRightSpill: {
					const extraPages = _.range(startPage - spillOffset, startPage);
					pages = [LEFT_PAGE, ...extraPages, ...pages];
					break;
				}

				// handle: (1) {2 3} [4] {5 6} > (10)
				case !hasLeftSpill && hasRightSpill: {
					const extraPages = _.range(endPage + 1, endPage + spillOffset + 1);
					pages = [...pages, ...extraPages, RIGHT_PAGE];
					break;
				}

				// handle: (1) < {4 5} [6] {7 8} > (10)
				case hasLeftSpill && hasRightSpill:
				default: {
					pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
					break;
				}
			}

			return [
				this.props.currentViewPage === 1 ? 1 : START_PAGE,
				...pages,
				this.props.currentViewPage === totalPages ? totalPages : LAST_PAGE,
			];
		}

		return _.range(1, totalPages + 1);
	};

	renderPageNavBar = () => {
		const pages = this.fetchPageNumbers();

		return (
			<div
				className={'outer-header2'}
				style={
					{
						// width: _.has(this.props, 'width') ? this.props.width : '',
					}
				}
			>
				<>
					<span className="left-outer-header2">
						{(this.props.currentViewPage - 1) * this.props.limit +
							1 +
							' - ' +
							(this.props.currentViewPage === this.props.totalPages
								? this.props.lengthOfList
								: this.props.currentViewPage * this.props.limit) +
							' of ' +
							this.props.lengthOfList}
					</span>
					<span className="right-outer-header2">
						<span className="page-text2">
							{_.map(pages, (page, i) => {
								if (page === 'Start') {
									return (
										<a
											className="left-chevron2"
											onClick={() => this.props.goToPage(1)}
										>
											<ChevronLeftIcon />
											<ChevronLeftIcon />
										</a>
									);
								}

								if (page === 'Left') {
									return (
										<a
											className="left-chevron2"
											onClick={() => {
												!this.props.isPageLoading &&
													this.props.onClickPreviousPage();
											}}
										>
											<ChevronLeftIcon />
										</a>
									);
								}
								if (page === 'Right') {
									return (
										<a
											className="right-chevron2"
											onClick={() => {
												!this.props.isPageLoading &&
													this.props.onClickNextPage();
											}}
										>
											<ChevronLeftIcon />
										</a>
									);
								}

								if (page === 'End') {
									return (
										<a
											className="right-chevron2"
											onClick={() =>
												this.props.goToPage(this.props.totalPages)
											}
										>
											<ChevronLeftIcon />
											<ChevronLeftIcon />
										</a>
									);
								}

								return (
									<a
										onClick={() => this.props.goToPage(page)}
										key={page}
										className={
											this.props.currentViewPage == page ? 'active' : ''
										}
									>
										{page}
									</a>
								);
							})}
						</span>
					</span>
					{/* <span className="right-outer-header">
						<span
							className="left-chevron"
							onClick={() => {
								!this.props.isPageLoading && this.props.onClickPreviousPage();
							}}
						>
							<ChevronLeftIcon />
						</span>
						<span className="page-text"> 
							{[...Array(this.props.totalPages)].map((e, i) => (
								<a
									onClick={() => this.props.goToPage(i + 1)}
									key={i}
									className={this.props.currentViewPage == i + 1 ? 'active' : ''}
								>
									{i + 1}
								</a>
							))}
						</span>
						{this.props.currentViewPage === this.props.totalPages ? (
							<span className="right-chevron" style={{ visibility: 'hidden' }}>
								<ChevronLeftIcon />
							</span>
						) : (
							<span
								className="right-chevron"
								onClick={() => {
									!this.props.isPageLoading && this.props.onClickNextPage();
								}}
							>
								<ChevronLeftIcon />
							</span>
						)}
					</span> */}
				</>
			</div>
		);
	};

	handleSort = (sortBy) => {
		if (_.has(this.props, 'module') && this.props.module === 'project')
			this.setState(
				{
					[`${sortBy}SortType`]:
						this.state[`${sortBy}SortType`] == 1
							? -1
							: this.state[`${sortBy}SortType`] == 0
							? 1
							: 0,
				},
				() => this.props.handleSort(sortBy, this.state[`${sortBy}SortType`]),
			);
		else {
			this.setState(
				{
					[`${sortBy}SortType`]: this.state[`${sortBy}SortType`] == 1 ? -1 : 1,
				},
				() => this.props.handleSort(sortBy, this.state[`${sortBy}SortType`]),
			);
		}
	};
	renderTable = () => {
		return (
			<table>
				<thead
					style={{
						top: _.has(this.props, 'tableTop')
							? this.props.tableTop
							: _.has(this.props, 'asset')
							? '95px'
							: _.has(this.props, 'attendanceDetails')
							? '80px'
							: '165px',
					}}
				>
					<tr>
						{_.map(this.props.columns, (column, key) => {
							return (
								<th
									style={{
										backgroundColor: _.has(this.props, 'ptProps')
											? '#1C1C1C'
											: '',
										borderRight: _.has(this.props, 'ptProps')
											? '0.4px solid #383838'
											: '',
										borderRadius: _.has(this.props, 'ptProps') ? '0' : '',
									}}
									// className={
									//     _.has(column, 'className')
									//         ? column.className
									//         : 'all-other-column-fixed2'
									// }
								>
									<div
										className="th-header2"
										onClick={() =>
											_.has(column, 'sortBy')
												? this.handleSort(column.sortBy)
												: ''
										}
									>
										{_.has(column, 'dummyPad') ? (
											<span
												className="dummy-pad2"
												style={
													{
														// minWidth:
														//     _.has(
														//         column,
														//         'dummyPad'
														//     ) &&
														//     _.has(
														//         column,
														//         'dummyPadWidth'
														//     )
														//         ? column.dummyPadWidth
														//         : '',
													}
												}
											></span>
										) : (
											''
										)}
										<p className="header-title2">
											{column.title}{' '}
											{_.has(column, 'lineBreakTitle') ? (
												<>
													{' '}
													<br /> {column.lineBreakTitle}
												</>
											) : (
												''
											)}
										</p>
										{_.has(column, 'sortBy') ? (
											<span
												className={
													'sort-icn' +
													(this.state[`${column.sortBy}SortType`] == -1
														? ' sort-visible'
														: this.state[`${column.sortBy}SortType`] ==
														  1
														? ' sort-visible sort-ascending'
														: ' sort-hidden')
												}
											>
												<Down />
											</span>
										) : (
											''
										)}
									</div>
								</th>
							);
						})}
						{/* <th className="first-column-fixed">
							<div
								className="th-header"
								onClick={() => this.props.handleProjectSort('title')}
							>
								<span className="dummy-pad"></span>
								<span className="header-title">Name</span>
								<span
									className={
										'sort-icn' +
										(this.props.sortBy === 'title'
											? this.props.sortType === -1
												? ' sort-visible'
												: ' sort-visible sort-ascending'
											: '')
									}
								>
									<Down />
								</span>
							</div>
						</th>
						<th className="wedding-details-column">
							<div
								className="th-header"
								onClick={() => this.props.handleProjectSort('weddingDate')}
							>
								<span className="header-title">
									Wedding
									<br />
									Details
								</span>
								<span
									className={
										'sort-icn' +
										(this.props.sortBy === 'weddingDate'
											? this.props.sortType === -1
												? ' sort-visible'
												: ' sort-visible sort-ascending'
											: '')
									}
								>
									<Down />
								</span>
							</div>
						</th>
						<th className="all-other-column-fixed">
							<div className="th-header">
								<span className="header-title">
									Quotation
									<br />
									Price
								</span>
							</div>
						</th>
						<th className="all-other-column-fixed">
							<div className="th-header">
								<span className="header-title">
									Total
									<br />
									Expenses
								</span>
								<span className="info">
									<InfoIcon
										data-tip
										data-for={`total-expense-project-list-table`}
										data-event="click"
									/>
									{this.renderToolTip(
										`total-expense-project-list-table`,
										'Total expenses of a project billed to client & included in the package cost.',
									)}
								</span>
							</div>
						</th>
						<th className="all-other-column-fixed">
							<div className="th-header">
								<span className="header-title">
									Completed
									<br />
									Shoots
								</span>
							</div>
						</th>
						<th className="all-other-column-fixed">
							<div className="th-header">
								<span className="header-title">
									Pending
									<br />
									Payments
								</span>
							</div>
						</th>
						<th className="all-other-column-fixed">
							<div className="th-header">
								<span className="header-title">
									Completed
									<br />
									Deliverables
								</span>
							</div>
						</th> */}
					</tr>
				</thead>
				<tbody>{this.props.children}</tbody>
			</table>
		);
	};

	renderEmptyTab = (type = null) => {
		let userToken = localStorage.getItem('usertoken');
		let decoded = jwt_decode(userToken);
		let isDarkTheme = false;

		if (type === 'loading') {
			return (
				<div
					className="proposals-empty-container2"
					style={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
						height: 'calc(100vh - 120px)',
					}}
				>
					<LoadingBar barHeight="5px" />
				</div>
			);
		} else if (
			_.size(this.props.dataList) === 0 &&
			this.props.searchQuery.trim().length === 0 &&
			this.props.mainFilter !== 'All'
			/* this.props.dataList.length === 0 &&
			this.props.searchQuery.trim().length === 0 &&
			this.props.startDate !== new Date().setFullYear(2000) */
		) {
			return (
				<div
					className="proposalsf-empty-container2"
					style={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
						height: 'calc(100vh - 120px)',
					}}
				>
					{/* <img
						src={
							isDarkTheme ? '/empty-proposal-tab-dark.jpg' : '/empty-proposal-tab.jpg'
						}
						alt="empty projects"
						style={{ height: '400px' }}
					/> */}
					<div className="proposal-empty-head-title2">{`No ${this.props.mainFilter.toLowerCase()} Data`}</div>
					<div className="proposal-empty-title2">
						{`You don\’t have any ${this.props.mainFilter.toLowerCase()} data!`}
					</div>
				</div>
			);
		} else if (
			_.size(this.props.dataList) === 0 &&
			this.props.searchQuery.trim().length === 0
			/* this.props.dataList.length === 0 &&
			(this.props.searchQuery.trim().length === 0 ||
				this.props.startDate === new Date().setFullYear(2000)) */
		) {
			return (
				<div className="proposals-empty-container2">
					{/* <img
						src={
							isDarkTheme ? '/empty-proposal-tab-dark.jpg' : '/empty-proposal-tab.jpg'
						}
						alt="empty projects"
						style={{ height: '400px' }}
					/> */}
					<div className="proposal-empty-title2" style={{ marginBottom: '0px' }}>
						Your have not created any Projects.
					</div>
					<div className="proposal-empty-title2">
						Please go ahead and create a new project !
					</div>
					<div className="proposal-add-button2" onClick={this.props.handleCreateProject}>
						<span className="plus-icon">+ </span>
						<span style={{ fontSize: '11px' }}>NEW PROJECT</span>
					</div>
				</div>
			);
		} else {
			return (
				<div className="proposals-empty-container2">
					<img
						src={
							isDarkTheme
								? '/empty-search-proposal-dark.jpg'
								: '/empty-search-proposal.jpg'
						}
						alt="empty proposals"
						style={{ height: '400px' }}
					/>
					<div className="proposal-empty-head-title2">No results</div>
					<div className="proposal-empty-title2">
						We cannot find items you searched for!
					</div>
				</div>
			);
		}
	};
	render() {
		return (
			<>
				<div className="projects-table-outer-container2">
					{this.props.isPageLoading === true ? (
						this.renderEmptyTab('loading')
					) : _.size(this.props.dataList) === 0 && this.props.isPageLoading == false ? (
						this.renderEmptyTab()
					) : (
						<>
							{this.renderTable()}
							{_.has(this.props, 'noPagination') && this.props.noPagination == true
								? ''
								: this.renderPageNavBar()}
						</>
					)}
				</div>
			</>
		);
	}
}
export default withRouter(DataTableCompact);
